// Data-driven content for the five service pages.
// Truthful only: no invented guarantee, delay, statistic or claim.

export const SERVICES = {
  "infogerance-informatique": {
    navLabel: "Infogérance informatique",
    seoTitle: "Infogérance informatique pour entreprise",
    seoDescription:
      "Umbo prend en charge l’infogérance informatique de votre entreprise : support, postes, réseau, messagerie, cybersécurité et sauvegardes. Une seule équipe, une seule facture.",
    kicker: "Le service",
    title: "Nous devenons votre service informatique.",
    intro:
    "Une seule équipe prend en charge l’infogérance informatique de votre entreprise : postes, messagerie, réseau, téléphonie, cybersécurité, sauvegardes et support au quotidien.",
    sections: [
      {
        heading: "Le problème que vous vivez",
        paragraphs: [
          "Dans une entreprise de trois à neuf personnes, l'informatique n'appartient à personne. Le dirigeant s'en occupe entre deux rendez-vous, une secrétaire débrouillarde fait ce qu'elle peut, et quand plus rien ne fonctionne, on cherche dans ses contacts le numéro du dépanneur qui était déjà venu l'an dernier.",
          "Résultat : chaque incident se transforme en perte de temps. Un ordinateur qui ne démarre plus, une boîte mail saturée, une imprimante réseau qui disparaît, un nouveau salarié à équiper. Personne ne suit vraiment l'état du parc, personne n'anticipe, et les mêmes problèmes reviennent parce qu'ils ne sont jamais traités à la racine.",
          "Vous n'avez pas de service informatique, et vous n'en aurez jamais. C'est parfaitement normal : votre métier, c'est le vôtre, pas la gestion d'un parc d'ordinateurs.",
        ],
      },
      {
        heading: "Notre réponse",
        paragraphs: [
          "Nous devenons, tout simplement, le service d’infogérance informatique de votre entreprise. Un seul interlocuteur prend en charge l’ensemble : vos postes de travail, votre messagerie professionnelle et votre bureautique, votre réseau, votre téléphonie, la cybersécurité, les sauvegardes et le support au quotidien.",
          "Concrètement, vos équipes n'ont plus qu'un seul numéro à composer quand quelque chose ne va pas. En face, une équipe qui connaît déjà votre installation, vos habitudes et vos priorités — pas un centre d'appel anonyme qui redécouvre votre dossier à chaque appel.",
          "Nous surveillons vos systèmes en permanence pour intervenir souvent avant même que vous ne remarquiez un problème, et nous entretenons votre parc dans la durée plutôt que de courir d'urgence en urgence.",
        ],
      },
      {
        heading: "Ce que ça change pour vous",
        items: [
          "Une seule facture et un seul contact, au lieu de plusieurs prestataires à coordonner.",
          "Des équipes qui perdent moins de temps sur des problèmes techniques.",
          "Un parc suivi et entretenu, pas seulement réparé quand il casse.",
          "L'arrivée d'un nouveau salarié préparée sans stress.",
        ],
      },
    ],
  },

  cybersecurite: {
    navLabel: "Cybersécurité",
    promoAudit: true,
    seoTitle: "Cybersécurité pour entreprise et TPE",
    seoDescription:
      "Protégez votre entreprise contre les virus, rançongiciels et accès frauduleux avec une cybersécurité complète : protection des postes, MFA, gestion des mots de passe et surveillance continue.",
    kicker: "Le service",
    title: "La même protection pour tous, sans formule au rabais.",
   intro:
  "Notre cybersécurité pour entreprise protège chaque poste, chaque accès et chaque collaborateur avec le même niveau d’exigence, quelle que soit la taille de votre TPE.",
    sections: [
      {
        heading: "Le problème que vous vivez",
        paragraphs: [
          "On vous parle de sécurité informatique surtout quand il est trop tard : après le mail piégé sur lequel quelqu'un a cliqué, après le virement détourné, après la matinée passée à comprendre pourquoi plus personne n'accède à ses fichiers. Le reste du temps, le sujet reste flou, technique, un peu anxiogène — alors on repousse.",
          "Beaucoup de prestataires proposent d'ailleurs des formules d'entrée de gamme, allégées en sécurité, pour afficher un prix plus bas. La petite entreprise se retrouve avec une protection au rabais, sans le savoir, jusqu'au jour de l'incident.",
        ],
      },
      {
        heading: "Notre réponse",
        paragraphs: [
        "Nous refusons ce compromis. Notre cybersécurité pour entreprise repose sur un principe simple : seuls les logiciels explicitement autorisés peuvent s’exécuter. Les virus, rançongiciels et applications non autorisées sont bloqués avant leur lancement, y compris face aux menaces inconnues.",
          "Nous incluons surtout deux clés de sécurité physiques par personne, offertes. C'est un petit objet que le salarié branche sur son ordinateur pour se connecter : même si son mot de passe est volé, personne ne peut accéder à ses comptes sans la clé. Très peu de prestataires de notre taille le proposent. Vous en devenez propriétaire, une principale et une de secours, et vous ne les restituez jamais.",
          "Nous ajoutons la gestion sécurisée des mots de passe de toute l'équipe, la sensibilisation régulière de vos collaborateurs aux tentatives d'arnaque, et une surveillance permanente de vos systèmes.",
        ],
      },
      {
        heading: "Vous serez enfin assurable",
        paragraphs: [
          "Les assureurs qui couvrent le risque informatique exigent aujourd'hui un socle de mesures précis pour accepter d'assurer une petite entreprise. Beaucoup de dirigeants découvrent, au moment d'un sinistre, qu'ils ne remplissaient pas ces critères — et que leur couverture ne joue pas.",
          "Notre offre coche ces critères par construction. Cela facilite l'obtention d'une couverture auprès de votre propre assureur. Pour être clair : nous ne vendons ni ne fournissons aucune assurance ; nous mettons simplement votre entreprise en conformité avec ce que les assureurs attendent.",
        ],
      },
      {
        heading: "Le wifi visiteurs, et vous êtes en règle",
        paragraphs: [
          "Dès qu'une entreprise ouvre son wifi à ses clients ou à ses visiteurs, elle devient responsable de cet accès. La loi française l'oblige alors à conserver les journaux de connexion pendant un an — une obligation que la plupart des établissements qui offrent du wifi ignorent complètement.",
          "Si vous accueillez du public — hôtel, restaurant, café, salle d'attente, espace de coworking, commerce — nous installons pour vous un wifi visiteurs conforme : une page d'accueil à vos couleurs, un accès gratuit ou payant selon votre choix avec gestion des codes, un réseau totalement séparé du vôtre pour que vos clients ne voient jamais vos données, et la conservation des journaux de connexion pendant un an comme la loi l'exige. Le tout installé, configuré et administré par nos soins.",
        ],
      },
      {
        heading: "Ce que ça change pour vous",
        items: [
          "Le vol d'un mot de passe ne suffit plus à compromettre vos comptes.",
          "Vos équipes savent reconnaître les tentatives d'arnaque les plus courantes.",
          "Vous êtes en position d'obtenir une couverture auprès de votre assureur.",
          "La sécurité n'est plus un sujet que vous repoussez.",
        ],
      },
    ],
  },

  "sauvegarde-informatique": {
    navLabel: "Sauvegarde informatique",
    seoTitle: "Sauvegarde informatique pour entreprise",
    seoDescription:
      "Sécurisez les données de votre entreprise avec des sauvegardes vérifiées de vos ordinateurs et de votre messagerie, pour garantir une restauration rapide en cas d’incident.",
    kicker: "Le service",
    title: "Une sauvegarde dont quelqu'un vérifie qu'elle fonctionne.",
   intro:
  "Notre sauvegarde informatique pour entreprise protège vos données, vos postes et votre messagerie, avec des sauvegardes vérifiées pour s’assurer qu’elles restent réellement restaurables en cas d’incident.",
    sections: [
      {
        heading: "Le problème que vous vivez",
        paragraphs: [
          "Beaucoup d'entreprises pensent être sauvegardées. Un disque dur branché dans un tiroir, une copie faite « de temps en temps », un outil installé il y a des années dont plus personne ne surveille les alertes. Sur le papier, une sauvegarde existe. En pratique, personne ne sait si elle est complète, ni si on pourrait vraiment récupérer ses données.",
          "Et c'est le jour de l'incident — un ordinateur volé, un rançongiciel, une fausse manipulation — que la mauvaise surprise arrive : la sauvegarde s'était arrêtée depuis des mois, ou ne contenait pas ce qu'il fallait.",
        ],
      },
      {
        heading: "Notre réponse",
        paragraphs: [
         "Nous mettons en place une sauvegarde informatique pour votre entreprise couvrant vos ordinateurs et votre messagerie, et surtout nous vérifions qu’elle fonctionne. Une sauvegarde n’a de valeur que si vos données peuvent réellement être restaurées lorsqu’un incident survient.",
          "Si un poste tombe, si un fichier est supprimé par erreur, ou si un rançongiciel tente de chiffrer vos données, l'objectif reste le même : que vos informations soient restaurables et que votre activité reprenne au plus vite.",
          "Cette sauvegarde fait partie de nos deux formules. Vous n'avez rien à installer, rien à surveiller, rien à vérifier vous-même.",
        ],
      },
      {
        heading: "Ce que ça change pour vous",
        items: [
          "Vos données restent restaurables, même après un incident sérieux.",
          "Vous ne dépendez plus d'un disque dur oublié dans un tiroir.",
          "Quelqu'un s'assure vraiment que la sauvegarde tourne, à votre place.",
          "Une erreur de manipulation ne se transforme plus en catastrophe.",
        ],
      },
    ],
  },

  "telephonie-entreprise": {
    navLabel: "Téléphonie & internet",
    seoTitle: "Téléphonie d’entreprise à Lille",
    seoDescription:
      "Téléphonie d’entreprise à Lille avec fibre professionnelle, secours 4G automatique et conservation de vos numéros. Un seul interlocuteur pour votre connexion et vos communications.",
    kicker: "Le service",
    title: "Votre connexion et votre téléphonie, sans coupure.",
    intro:
  "Notre solution de téléphonie d’entreprise à Lille regroupe vos communications et votre connexion fibre professionnelle, avec secours 4G automatique pour maintenir votre activité en cas de coupure.",
    sections: [
      {
        heading: "Le problème que vous vivez",
        paragraphs: [
          "Aujourd'hui, votre internet vient d'un fournisseur, votre téléphonie d'un autre, et quand la connexion tombe, vous vous retrouvez à jongler entre deux services clients qui se renvoient la responsabilité. Pendant ce temps, vos équipes ne reçoivent plus d'appels et ne peuvent plus travailler.",
          "Une coupure d'internet, pour une petite entreprise, ce sont des clients qui n'arrivent pas à vous joindre, des paiements bloqués, une matinée perdue. Et rares sont les TPE qui ont prévu une solution de secours.",
        ],
      },
      {
        heading: "Notre réponse",
        paragraphs: [
         "Nous fournissons aux entreprises de Lille une connexion internet fibre professionnelle avec bascule automatique sur un secours 4G. Si la fibre tombe, votre activité continue pendant que la ligne principale est rétablie.",
          "Nous prenons également en charge votre téléphonie d'entreprise, en conservant vos numéros actuels — vos clients continuent de vous appeler comme avant, sans rien changer. La téléphonie est comprise dans la limite d'un usage professionnel normal ; les modalités précises figurent à votre contrat.",
          "Comme le reste, internet et téléphonie relèvent du même interlocuteur. En cas de souci, un seul numéro à appeler, et personne pour se renvoyer la responsabilité.",
        ],
      },
      {
        heading: "Ce que ça change pour vous",
        items: [
          "Une coupure de fibre ne vous met plus à l'arrêt, grâce au secours 4G.",
          "Vous conservez vos numéros de téléphone actuels.",
          "Un seul interlocuteur pour internet et téléphonie.",
          "Plus de renvoi de responsabilité entre fournisseurs.",
        ],
      },
    ],
  },

  "maintenance-informatique": {
    navLabel: "Maintenance & support",
    seoTitle: "Maintenance informatique pour entreprise",
    seoDescription:
      "Maintenance informatique pour entreprise avec support illimité, supervision 24h/24 et intervention rapide. Umbo assure le suivi et la continuité de votre parc informatique.",
    kicker: "Le service",
    title: "Quelqu'un qui répond, et qui veille pendant que vous travaillez.",
   intro:
  "Notre maintenance informatique pour entreprise combine support réactif, supervision permanente et interventions encadrées, pour garder votre parc fiable et vos équipes opérationnelles.",
    sections: [
      {
        heading: "Le problème que vous vivez",
        paragraphs: [
          "Quand un problème informatique survient, le pire est l'incertitude : à qui téléphoner, combien de temps avant que quelqu'un s'en occupe, et surtout est-ce que la personne au bout du fil comprend votre situation. Pendant que le compteur tourne, votre équipe attend.",
          "Beaucoup de petites entreprises n'ont aucune visibilité sur l'état de leurs systèmes. Les problèmes ne sont détectés que lorsqu'ils deviennent visibles, c'est-à-dire une fois qu'ils ont déjà des conséquences.",
        ],
      },
      {
        heading: "Notre réponse",
        paragraphs: [
         "Notre maintenance informatique pour entreprise comprend un support illimité par téléphone et à distance, du lundi au vendredi de 8h à 18h, assuré par une équipe qui connaît votre installation. En complément, nous surveillons vos systèmes 24h/24 et 7j/7 afin de détecter et traiter de nombreux problèmes avant qu'ils n'affectent votre activité.",
          "Lorsqu'une intervention est nécessaire, nous nous engageons sur un délai clair : sous 4 heures ouvrées, et sous 2 heures si votre activité est complètement à l'arrêt. Deux interventions sur site sont par ailleurs incluses chaque année, et le remplacement du matériel défectueux est pris en charge.",
          "Ce sont là nos engagements, écrits noir sur blanc. Nous préférons tenir exactement ce que nous annonçons plutôt que de promettre l'impossible.",
        ],
      },
      {
        heading: "Ce que ça change pour vous",
        items: [
          "Vous savez précisément qui appeler et sous quel délai on intervient.",
          "Beaucoup de problèmes sont traités avant même que vous les remarquiez.",
          "Deux visites sur site par an, en plus du support à distance.",
          "Le remplacement du matériel défectueux ne devient pas un budget imprévu.",
        ],
      },
    ],
  },
};

export const SERVICE_ORDER = [
  "infogerance-informatique",
  "cybersecurite",
  "sauvegarde-informatique",
  "telephonie-entreprise",
  "maintenance-informatique",
];
